module.exports = __webpack_public_path__ + "91fc82ec02fce94743e17ada4e7bcc02.svg";